var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaudiArabia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 39.9999C31.0459 39.9999 40.0002 31.0456 40.0002 19.9999C40.0002 8.95418 31.0459 -0.00012207 20.0002 -0.00012207C8.95449 -0.00012207 0.000183105 8.95418 0.000183105 19.9999C0.000183105 31.0456 8.95449 39.9999 20.0002 39.9999Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3044 23.9129C11.3044 25.3536 12.4724 26.5216 13.9131 26.5216H21.7391C21.7391 27.7222 22.7124 28.6955 23.9131 28.6955H26.5217C27.7224 28.6955 28.6956 27.7222 28.6956 26.5216V23.9129H11.3044Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9129 11.3044V17.3913C28.9129 18.3503 28.1328 19.1305 27.1738 19.1305V21.7391C29.5712 21.7391 31.5216 19.7887 31.5216 17.3913V11.3044H28.9129Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2175 17.3913C10.2175 18.3503 9.43732 19.1305 8.47833 19.1305V21.7391C10.8758 21.7391 12.8261 19.7887 12.8261 17.3913V11.3044H10.2175V17.3913Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 11.3044H27.6086V17.3913H24.9999V11.3044Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0869 14.7825C21.0869 15.0222 20.8919 15.2172 20.6522 15.2172C20.4125 15.2172 20.2174 15.0222 20.2174 14.7825V11.3042H17.6087V14.7825C17.6087 15.0222 17.4136 15.2172 17.174 15.2172C16.9343 15.2172 16.7392 15.0222 16.7392 14.7825V11.3042H14.1304V14.7825C14.1304 16.4607 15.4958 17.826 17.174 17.826C17.8203 17.826 18.4197 17.6229 18.9131 17.2779C19.4065 17.6228 20.0059 17.826 20.6522 17.826C20.7824 17.826 20.9104 17.8169 21.0362 17.8008C20.8514 18.5625 20.1654 19.1303 19.3479 19.1303V21.739C21.7453 21.739 23.6957 19.7885 23.6957 17.3912V14.7825V11.3042H21.087V14.7825H21.0869Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1304 19.1304H18.0435V21.739H14.1304V19.1304Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1241"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaudiArabia);
export default __webpack_public_path__ + "static/media/saudi_arabia.fbf2d15a20758ae1743a1add63f4cb6a.svg";
export { ForwardRef as ReactComponent };